import React from 'react';
import {RichText} from '@gongxigames/framework/core/fragments/react';

type TextProps = {
    x?: number;
    y?: number;
    style: string;
    value: string | {id: string;};
};

export const MessagePopupTextComponent = (props: TextProps): JSX.Element => {
    const name = 'MessagePopupTextComponent';
    const {
        value,
        ...otherProps
    } = props;

    if (typeof value === 'string') {
        return <RichText id={'errorPopupTitleTemplate'} name={name} values={{title: value}} {...otherProps} resolution={1}/>;
    } else {
        return <RichText id={value.id} name={name} {...otherProps} resolution={1}/>;
    }
};
